import { AppScrollWrapperNew } from '../../../widgets/AppScrollWrapper/AppScrollWrapper'
import { OrderLineItem } from './OrderLineItem'
import { IPlanMenuControlOrdersRequest } from 'core/api/dto/PlanMenuControlDto'
import { useSearchParams } from 'react-router-dom'
import { Dispatch, SetStateAction } from 'react'

import { useGetPlanMenuCloseOrderQuery } from 'core/api/PlanMenuCloseApi'

interface IOrderLineListProps {
  pageParams?: IPlanMenuControlOrdersRequest | null
  setIsShowPopup: () => void
  isAll?: boolean
  onOffsetChange?: Dispatch<SetStateAction<number>>
}

export const OrderLineList = ({
  setIsShowPopup,
  isAll,
  onOffsetChange,
}: IOrderLineListProps) => {
  const [searchParams] = useSearchParams()
  const currentOrderId = searchParams.get('order')
  const { data } = useGetPlanMenuCloseOrderQuery({
    id: Number(currentOrderId!),
  })

  return (
    <div className="history-block">
      <AppScrollWrapperNew theme="dropdown">
        {data &&
          data?.orderLines?.map((orderItem, index) => (
            <div key={index} style={{ marginRight: 10 }}>
              <OrderLineItem
                orderItem={orderItem}
                setIsShowPopup={setIsShowPopup}
                isAll={isAll}
                onOffsetChange={onOffsetChange}
              />
            </div>
          ))}
      </AppScrollWrapperNew>
    </div>
  )
}
